const Card = ({ children, title, subtitle, className = '', ...props }) => {
  return (
    <div className={`card ${className}`} {...props}>
      {title && (
        <div className="mb-4">
          <h2 className="text-xl md:text-2xl font-semibold text-text-dark mb-1">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-text-secondary">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  )
}

export default Card
